export function heroHome() {
    var body                = document.body;
    var docEl               = document.documentElement;
    var scrollTop           = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var clientTop           = docEl.clientTop || body.clientTop || 9;
    var _has_fixed_btn      = $('.order-link').hasClass('fixed-mobile');
    var _no_fixed_button    = $('.order-link:not(.fixed-mobile)');
    var buttons             = document.querySelector(".hero-section .buttons");
    var hero_top            = 500;

    if(buttons){
        var box     = buttons.getBoundingClientRect();
        hero_top    = box.top + scrollTop - clientTop;       
        $(".header").addClass("logo-min");
    }

    $(window).on('scroll', function () {
        var hero_scroll     = $(window).scrollTop();
        var _has_blackBg    = $(".header").hasClass("blackBg");
        var _width          = $(window).width();

        if (hero_scroll >= hero_top) {
            $('#main-logo-min').show();
            if (!_has_blackBg) {
                $(".header").addClass("blackBg");
            }
            if (_width < 1200) {
                _no_fixed_button.removeClass("visibility-visible").addClass('visibility-hidden');
                if (_has_fixed_btn) {
                    $('.fixed-mobile').addClass("hero-order-fixed");
                }
            }
        } else {
            $('#main-logo-min').hide();
            if (_has_blackBg) {
                $(".header").removeClass("blackBg");
            }

            if (_width < 1200) {
                _no_fixed_button.removeClass('animate-hidden').addClass('visibility-visible');
                if (_has_fixed_btn) {
                    $('.fixed-mobile').removeClass("hero-order-fixed");
                }

            }
        }

    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hero-home.js